import BoilerplateForm from './boilerplate_form';
import { html, nothing } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { ifDefined } from 'lit/directives/if-defined.js';

export class WishlistEditBoardForm extends BoilerplateForm {
  static get properties() {
    return {
      success: { type: Boolean, state: true },
      board: { type: Object, attribute: true },
    };
  }

  constructor() {
    super();
    this.useUrlParams = false;
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.errors = {};
    this.genericErrorSegments = [];
    this.busy = true;
    this.loading = true;
    this.success = false;

    const fields = this.objectData;

    try {
      await window.wishlist.editBoard(this.board.id, {
        boardName: fields.boardName,
        colour: fields.boardColour,
        emoji: fields.boardEmoji,
      });

      this.handleSuccess();
    } catch (error) {
      const errorArr = Array.isArray(error) ? error : [error];
      this.handleErrors(errorArr);
    } finally {
      this.busy = false;
      this.loading = false;
    }
  }

  renderFormElements() {
    if (!this.board) return nothing;

    const colours =
      window.wishlist_colours?.filter((c) => !c.value.startsWith('_')) ||
      window.wishlist_colours;

    return html`<div class="form_wishlist_board" dropdown-parent>
      <float-field
        value=${this.board.name}
        type="text"
        minlength="3"
        maxlength="25"
        name="boardName"
        id=${`${this.id}_boardName`}
        label="Board Name"
        required
        error="Please enter a name for your board"
        placeholder="Name"
      ></float-field>
      <div class="float_dropdowns_container">
        <float-dropdown
          value=${this.board.emoji}
          name="boardEmoji"
          id=${`${this.id}_boardEmoji`}
          type="emoji"
          .options=${window.wishlist_emojis}
          aria-label="Emoji picker dropdown"
        >
        </float-dropdown>
        <float-dropdown
          value=${this.board.colour}
          id=${`${this.id}_boardColor`}
          name="boardColour"
          type="colour"
          .options=${colours}
          aria-label="Colour picker dropdown"
        ></float-dropdown>
      </div>
    </div>`;
  }

  handleSuccess() {
    this.handleClose();
  }

  handleClose() {
    const event = new CustomEvent('modal-wishlist-edit-board:close');
    document.dispatchEvent(event);
  }

  renderInitial() {
    return html`<form
      ${ref((el) => (this.form = el))}
      method=${ifDefined(this.method)}
      ?novalidate=${this.novalidate}
      enctype=${ifDefined(this.enctype)}
      class="${this.id}"
      action="javascript:void(0)"
    >
      ${this.renderFormElements()} ${this.renderButton()} ${this.renderErrors()}
    </form>`;
  }

  renderButton() {
    return html`
      <div class="form_same_line justify_center">
        <button
          type="button"
          class="btn btn-secondary w-100"
          @click=${this.handleClose}
          ?disabled=${this.loading || this.busy}
        >
          ${window.theme.strings.wishlist.cancel}
        </button>
        <button
          type="submit"
          class="btn btn-primary w-100"
          aria-label="Save"
          ?disabled=${this.loading || this.busy}
          aria-busy=${this.loading || this.busy ? 'true' : 'false'}
        >
          ${this.loading
            ? html`<bouncing-ellipsis></bouncing-ellipsis>`
            : html`${window.theme.strings.wishlist.save}`}
        </button>
      </div>
    `;
  }
}

window.customElements.get('wishlist-edit-board-form') ||
  window.customElements.define(
    'wishlist-edit-board-form',
    WishlistEditBoardForm
  );
